import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { Conversation } from './ConsultationDetail';
import './MatchingDetail.css';
export default function MatchingDetail({
  admin = false
}) {
  const {
      id
    } = useParams(),
    [data, setData] = useState(null),
    [error, setError] = useState('');
  const base = `/api/agregator/${admin ? 'administration' : 'client'}/matching/${id}`;
  useEffect(() => {
    let active = true;
    setData(null);
    setError('');
    axios.get(base, {
      withCredentials: true
    }).then(r => {
      if (active) setData(r.data);
    }).catch(e => {
      if (active) setError(e.response?.data?.message || 'Не удалось загрузить заявку.');
    });
    return () => {
      active = false;
    };
  }, [base]);
  return <section className="matching-detail"><Link to={admin ? '/admin?section=therapy&tab=matchingApplications' : '/account'}>← {admin ? 'Заявки на подбор' : 'Личный кабинет'}</Link><header><span>ИНДИВИДУАЛЬНЫЙ ПОДБОР</span><h1>Подбор специалиста</h1></header>{error && <p role="alert">{error}</p>}{!data && !error && <p>Загрузка…</p>}{data && <><div className="matching-detail-info"><article><h2>{admin ? 'Запрос клиента' : 'Ваш запрос'}</h2><p>{data.request_description || 'Пожелания можно обсудить в чате.'}</p><p>Бюджет: {data.price_min == null && data.price_max == null ? 'не указан' : `${data.price_min ?? '—'} — ${data.price_max ?? '—'} ₽`}</p>{data.is_student && <p>Студент МАГ</p>}<small>Отправлено {new Date(data.created_at).toLocaleDateString('ru-RU')}</small></article><article><h2>{admin ? 'Контакты клиента' : 'Контактные данные'}</h2><strong>{data.last_name} {data.first_name}</strong><p><a href={'mailto:' + data.email}>{data.email}</a></p><p><a href={'tel:' + data.phone}>{data.phone}</a></p>{admin && data.preferred_contact && <p>{data.preferred_contact}</p>}</article></div>{data.client_id ? <Conversation key={base} endpoint={base + '/messages'} role={admin ? 'curator' : 'client'} /> : <p>У этой заявки ещё нет привязанного аккаунта. Свяжитесь с клиентом по указанным контактам.</p>}</>}</section>;
}
